import Localization from "../../../../localization";
import { Modal } from "../../../../components";
import useViewModel from "../../viewModel";
import Section from "./section";
import { useRef } from "react";
import Groups from "./groups";

const GroupsSection = ({ progress, ...props }) => {
  const { device, updateDistribution } = useViewModel();
  const groupsModalRef = useRef();

  const nrOfGroup = device.distribution?.recipients?.groups?.length ?? 0;

  return (
    <div {...props}>
      <Section
        title={Localization.general.other_groups}
        onEdit={() => groupsModalRef.current.open()}
        desc={Localization.service_edit_collaborators.group_desc}
        subtitle={`${nrOfGroup} ${
          nrOfGroup == 1
            ? Localization.general.group
            : Localization.general.groups
        }`.toLocaleLowerCase()}
        buttons={[
          {
            title: Localization.general.edit,
            onClick: () => groupsModalRef.current.open(),
          },
        ]}
      />
      <Modal
        ref={groupsModalRef}
        title={Localization.general.other_groups}
        child={() => (
          <Groups
            onCancel={() => groupsModalRef.current.close()}
            onConfirm={async (groups) => {
              await updateDistribution({ groups, progress });
              groupsModalRef.current.close();
            }}
          />
        )}
      />
    </div>
  );
};

export default GroupsSection;
